(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crocea-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  // Submit button UX — show "Sending…" so users don't double-submit on slow networks.
  document.querySelectorAll('[data-crocea-contact] .crocea-contact__form').forEach(function(form){
    var btn = form.querySelector('.crocea-contact__submit');
    if (!btn) return;
    form.addEventListener('submit', function(){
      var label = btn.querySelector('span');
      if (label) label.textContent = 'Sending…';
      btn.disabled = true;
    });
  });

  // Auto-scroll to success/error message after Shopify redirects back to the page
  var section = document.querySelector('[data-crocea-contact]');
  if (section) {
    var ok = section.querySelector('.crocea-contact__success');
    var err = section.querySelector('.crocea-contact__errors');
    var target = ok || err;
    if (target) {
      // Wait a tick so layout settles
      setTimeout(function(){
        target.scrollIntoView({behavior:'smooth', block:'center'});
      }, 100);
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
